import gnbudata from './raw/gnbu.json';

export const GnBuColorMap = type => {
  if (type === 'range') {
    return gnbudata;
  }
};
